import { render, staticRenderFns } from "./AdminCreateUser.vue?vue&type=template&id=38686faa"
import script from "./AdminCreateUser.vue?vue&type=script&lang=ts"
export * from "./AdminCreateUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports